export default __webpack_public_path__ + "static/media/header-shirts.80dbb2be.png";